import React from 'react';

import { GridFilterOperator } from '@mui/x-data-grid';

import { StyledSelect } from 'components/Input/styles';

import { PickerProps } from 'components/Grid/operators/types';

import { BaseStatusOperator } from '../Status/Status';

import { StyledMenuItem } from './styles';

export type ActiveStatusLabels = { active: string; inactive: string };

export type ActiveStatusOperatorSettings = {
  allowIsNot?: boolean;
};

const DEFAULT_LABELS: ActiveStatusLabels = { active: 'Active', inactive: 'Inactive' };

// Shared by the Events forms and Audits templates grids, which differ only in what they call the
// inactive state ("Inactive" vs "Archived"). The wire values stay 'true'/'false', or prefixed with '-'
// for "is not", so relabelling never changes the outgoing request.
const ActiveStatusPicker =
  (labels: ActiveStatusLabels): React.FunctionComponent<PickerProps> =>
  ({ applyValue, item, ...props }) => (
    <StyledSelect
      {...props}
      value={item.value}
      fullWidth
      onChange={(newValue) => applyValue({ ...item, value: newValue.target.value })}
    >
      <StyledMenuItem key="true" value="true">
        <p>{labels.active}</p>
      </StyledMenuItem>
      <StyledMenuItem key="false" value="false">
        <p>{labels.inactive}</p>
      </StyledMenuItem>
    </StyledSelect>
  );

export const ActiveStatusOperator = (
  labels: ActiveStatusLabels = DEFAULT_LABELS,
  { allowIsNot }: ActiveStatusOperatorSettings = {}
): GridFilterOperator[] => {
  const Picker = ActiveStatusPicker(labels);
  return BaseStatusOperator(
    Picker,
    undefined,
    (value) => (value === 'true' ? labels.active : labels.inactive),
    !allowIsNot,
    allowIsNot ? Picker : undefined
  );
};
